"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.get_access_details_thunk = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const user_1 = require("../user");
const main_1 = require("../../main");
const get_access_details_1 = require("../../../../api/calls/user/get_access_details");
exports.get_access_details_thunk = (0, toolkit_1.createAsyncThunk)("user/thunks/get_access_details", (arg, { dispatch, getState }) => __awaiter(void 0, void 0, void 0, function* () {
    const { data, token } = arg;
    dispatch((0, user_1.setIsLoading)(true));
    const { success, content, message } = yield (0, get_access_details_1.get_access_details)({ code: data.code }, token);
    dispatch((0, user_1.setIsLoading)(false));
    if (success) {
        dispatch((0, user_1.setAccessAuth)(content.access_details));
        return content;
    }
    else {
        // Check for authentication conflict
        if (content === null || content === void 0 ? void 0 : content.wrongUser) {
            // Return error details to caller (console.tsx) instead of showing modal
            return { error: content, message };
        }
        else {
            // Generic error handling for invalid/expired codes
            dispatch((0, main_1.setMessageModal)({ title: "Something went wrong!", messages: [message] }));
            return null;
        }
    }
}));
